import React from "react";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const AddtoCart = ({ product, selectedColor }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const norm = (v) => (v ?? "").toString().trim().toLowerCase();

  const variations = product?.color_images || [];
  const defaultImages = product?.default_images || [];

  // Dil değişse bile stabil: ürün + image imzası
  const makeVariantKey = (p, variation) => {
    const base = p.stock_code || p.id;
    const imgs = Array.isArray(variation?.images) ? variation.images : [];
    const sig = imgs.length ? imgs.join("|") : "default";
    return `${base}|${sig}`;
  };

  // selectedColor (Black/Siyah/أسود/...) -> doğru varyasyonu bul
  const resolveVariation = (sel) => {
    const s = norm(sel);
    if (!s || s === "default") return null;

    // 1) Direkt isim eşleşmesi (Black/Gold)
    let v = variations.find((x) => norm(x.name) === s);
    if (v) return v;

    // 2) Mevcut dil ve bilinen dillerde çeviri eşleşmesi
    const langs = Array.from(
      new Set([i18n.language, ...(i18n.languages || []), "en", "tr", "ar"])
    );
    v = variations.find((x) =>
      langs.some((lng) => {
        const a = norm(t(x.name, { lng, defaultValue: "" })); // t("Black") -> "Siyah/أسود"
        const b = norm(t(`colors.${x.name}`, { lng, defaultValue: "" })); // t("colors.Black")
        return (a && a === s) || (b && b === s);
      })
    );
    if (v) return v;

    // 3) Eğer sel URL ise, image listesinde ara
    const looksUrl = s.startsWith("http://") || s.startsWith("https://");
    if (looksUrl) {
      v = variations.find((x) =>
        (x.images || []).some((img) => norm(img) === s)
      );
      if (v) return v;
    }

    return null;
  };

  const addToCart = () => {
    const found = resolveVariation(selectedColor);

    // ✅ Sepete kaydedilecek varyasyon (name MUTLAKA gerçek varyasyon adı olsun)
    const finalVariation = found
      ? { name: found.name, images: found.images || [] }
      : { name: "Default", images: defaultImages };

    const variantKey = makeVariantKey(product, finalVariation);

    const cart = JSON.parse(localStorage.getItem("cart")) || [];

    const existingProductIndex = cart.findIndex((item) => {
      const itemVar = item.selectedVariation || {
        images: item.default_images || [],
      };
      const itemKey = item.variantKey || makeVariantKey(item, itemVar);
      return itemKey === variantKey;
    });

    if (existingProductIndex > -1) {
      if ((cart[existingProductIndex].quantity || 1) < 3) {
        cart[existingProductIndex].quantity += 1;
      } else {
        Swal.fire({
          icon: "warning",
          title: t("cart.limitReachedTitle"),
          text: t("cart.limitReachedText"),
          confirmButtonText: t("OK"),
        });
        return;
      }
    } else {
      cart.push({
        ...product,
        selectedVariation: finalVariation, // ✅ burada artık Black/Gold doğru kaydolur
        variantKey, // ✅ limit dil bağımsız kalır
        quantity: 1,
      });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    window.dispatchEvent(new Event("cartUpdated"));

    Swal.fire({
      icon: "success",
      title: t("cart.addedTitle", "Product added to cart"),
      toast: true,
      position: "bottom-end",
      showConfirmButton: false,
      timer: 1000,
      timerProgressBar: true,
    }).then(() => navigate("/cart"));
  };

  return (
    <button
      className="btn fw-14 bgcolorfooterbottom w-100 p-2 fw-normal mb-1"
      onClick={addToCart}
    >
      <i className="fa-solid fa-cart-plus fa-1x me-2"></i> {t("Add to Cart")}
    </button>
  );
};

export default AddtoCart;
